module.exports = __webpack_public_path__ + "static/media/amazon.ceced3af.svg";